'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Block = (_temp = _class = function (_Field) {
  _inherits(Block, _Field);

  function Block() {
    _classCallCheck(this, Block);

    return _possibleConstructorReturn(this, _Field.apply(this, arguments));
  }

  Block.prototype.componentDidMount = function componentDidMount() {
    var $state = this.props.$state;

    if ($state) {
      $state.set('disableCollect', true);
    }
  };

  Block.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-block'
    });
  };

  Block.prototype.renderChildren = function renderChildren(isDetail) {
    var children = this.props.children;

    if ((0, _lodash.isEmpty)(children)) {
      return null;
    }
    return children.map(function (child) {
      var componentSchema = JSON.parse(JSON.stringify(child.props.componentSchema));
      componentSchema.props.showLabel = false;
      if (isDetail) {
        componentSchema.props.readonly = true;
      }

      return _react2.default.cloneElement(child, _extends({}, child.props, {
        componentSchema: componentSchema
      }));
    });
  };

  Block.prototype.renderControl = function renderControl() {
    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      this.renderChildren()
    );
  };

  Block.prototype.renderView = function renderView() {
    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      this.renderChildren(true)
    );
  };

  return Block;
}(_vuFusionField2.default), _class.displayName = 'Block', _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), [{
  name: 'disableCollect',
  formatOut: function formatOut() {
    return true;
  }
}]), _temp);
exports.default = Block;
module.exports = exports['default'];